import { MUIChip } from "@abb/arcadia-ui-react"
import { useParams } from "react-router-dom"
import { useRoleUsers } from "../../../../../../hooks/useRoleUsers"
import { ApplicationRoleUser } from "../../../../../models/ApplicationRole"
import { ApplicationRoleStatus } from "../../../../../models/ApplicationRoleUser"
import {
  dateStringComparator,
  getNiceFormattedDate,
} from "../../../../../utils/getFormattedDate"
import { getUserApplicationStatusProps } from "../../../../../utils/getUserApplicationStatusProps"
import { EntityRow, EntityTab } from "../../../../partials/EntityTab"

export function ApplicationRoleUsers() {
  const { applicationId, roleId } = useParams()
  const { roleUsersList, isLoadingRoleUsers } = useRoleUsers(applicationId, roleId)

  const columns = [
    {
      field: "username",
      headerName: "Email address",
      isLink: true,
      linkBasePath: `/users`,
    },
    { field: "fullName", headerName: "Full name" },
    {
      field: "validityStartDate",
      headerName: "Validity Start Date",
      sortComparator: dateStringComparator,
    },
    {
      field: "validityEndDate",
      headerName: "Validity End Date",
      sortComparator: dateStringComparator,
    },
    {
      field: "status",
      headerName: "Status",
      renderCell: (row: EntityRow) => (
        <MUIChip
          {...getUserApplicationStatusProps(row.status as ApplicationRoleStatus)}
        />
      ),
    },
  ]

  const sorted = [...roleUsersList].sort((a, b) =>
    (a.username ?? "").localeCompare(b.username ?? "")
  )

  const rows = sorted.map((user: ApplicationRoleUser) => ({
    id: user.id,
    username: user.username,
    fullName: `${user.first ?? ""} ${user.last ?? ""}`.trim(),
    validityStartDate: getNiceFormattedDate(user.validityStartDate?.toString() ?? ""),
    validityEndDate: getNiceFormattedDate(user.validityEndDate?.toString() ?? ""),
    status: user.status,
  }))

  return <EntityTab rows={rows} cols={columns} isLoading={isLoadingRoleUsers} />
}
